export default __webpack_public_path__ + "static/media/csv_download.3b536f74.svg";